import { observable, computed, action, makeObservable, toJS } from "mobx";
import { select_addr_forkakao } from "../http/kakaoConn";
import { select_addr_fornaver } from "http/addrConn";

class ViewStore {
  constructor() {
    makeObservable(this);
  }

  /*********************/
  /* 상세 주문 객체      */
  /*********************/
  /**
   * 주문 상세 객체
   * @type {{orderType: string, payTypeView: string, stepCd: string, icon: string, elapseTime: string, deliveryStatusView: string, payFg: string, orderTypeView: string, orderAmount: string, payType: string, orderEndFgView: string, orderTime: string, viewTime: string, mobileOrderNoView: string, viewProdCnt: string, requestYn: string, mobileOrderFg: string, mobileOrderNo: string, tableNm: string, cookTime: string, mobileOrderFgNm: string, orderEndFg: string, isNew: boolean, dlvAddrCard: string, dlvAddr: string, viewTimePrefix: string, timeColor: string, partnerType: string, orderTimeView: string, viewProdNm: string, deliveryStatus: string, viewProds: null, tableCd: string}}
   * @private
   */
  @observable
  _st_order_detail = {
    shopCd: "",
    saleDate: "",
    orderNo: "",
    posNo: "",
    billNo: "",
    icon: "",
    isNew: false,
    hookComment: "",
    partnerType: "",
    mobileOrderFg: "",
    //mobileOrderFgNm: "",
    morderTypeCd: "",
    orderType: "",
    orderTypeView: "",
    mobileOrderNo: "",
    mobileOrderNoView: "",
    dlvAddr: "",
    dlvAddrDetail: "",
    dlvAddrFull: "",
    cstTelNo: "",
    cstNm: "",
    shopMessage: "",
    dlvMessage: "",
    shopMemo: "",
    orderAmount: "",
    orderTotAmount: "", // 할인전 전체금액
    totDcAmount: "", // 총 할인액
    gstPayAmt: "", // 받은 금액
    payType: "",
    payTypeView: "",
    payFg: "",
    //deliveryStatus: "",
    deliveryStatusView: "",
    requestYn: "",
    dlvStatusFg: "",
    dlvTargetCd: "",
    dlvPtnerCd: "",
    dlvPtnerNm: "",
    ptnerRiderTel: "",
    ptnerRiderNm: "",
    dlvDefFee: "",
    dlvExtFee: "",
    dlvReqTime: "",
    dlvPickupTime: "",
    dlvDeliveryTime: "",
    //tpayDeliveryId: "",
    stepCd: "",
    stepType: "",
    //orderEndFg: "",
    //orderEndFgView: "",
    orderTime: "",
    orderTimeView: "",
    cookTime: "",
    elapseTime: "",
    viewTimePrefix: "",
    viewTime: "",
    //timeColor: "",
    //tableCd: "",
    tableNm: "",
    viewProdNm: "",
    //viewProdCnt: "",
    viewProds: null,
    new_yn: "N",
  };

  /**
   * 주문 상세 객체 조회
   * @returns {{orderType: string, payTypeView: string, stepCd: string, icon: string, elapseTime: string, deliveryStatusView: string, payFg: string, orderTypeView: string, orderAmount: string, payType: string, orderEndFgView: string, orderTime: string, viewTime: string, mobileOrderNoView: string, viewProdCnt: string, requestYn: string, mobileOrderFg: string, mobileOrderNo: string, tableNm: string, cookTime: string, mobileOrderFgNm: string, orderEndFg: string, isNew: boolean, dlvAddrCard: string, dlvAddr: string, viewTimePrefix: string, timeColor: string, partnerType: string, orderTimeView: string, viewProdNm: string, deliveryStatus: string, viewProds: null, tableCd: string}}
   */
  @computed
  get getOrderDetail() {
    return toJS(this._st_order_detail) || {};
  }

  /**
   * 상세보기 일 경우 리스트에서 객체 셋팅
   * @param order
   * @returns {*}
   */
  @action
  setOrderDetail(orderList, mobileOrderNo) {
    this._st_order_detail = orderList.find(order => order.mobileOrderNo === mobileOrderNo);
  }

  @action
  getStatusOrderDetail(orderList, mobileOrderNo) {
    var orderDetail = orderList.find(order => order.mobileOrderNo === mobileOrderNo);
    if (
      orderDetail.mobileOrderNo != undefined &&
      orderDetail.mobileOrderNo != null &&
      orderDetail.mobileOrderNo != ""
    ) {
      return true;
    } else {
      return false;
    }
  }

  @action
  setOrderDetailBaemin(key, value) {
    this._st_order_detail = { ...this._st_order_detail, [key]: value };
  }

  /**
   * 상세객체 특정 항목 변경
   * @param key
   * @param value
   */
  @action
  setChangeViewObj(key, value) {
    this._st_order_detail = { ...this._st_order_detail, [key]: value };
  }

  /**
   * 상세팝업 노출여부
   * @type {boolean}
   * @private
   */
  @observable
  _st_detail_delivery_view = false;

  /**
   * 상세팝업 값 조회
   * @returns {boolean}
   */
  get getDetailView() {
    return this._st_detail_delivery_view;
  }

  /**
   * 상세팝업 닫기
   */
  @action
  setDetailClose() {
    this._st_detail_delivery_view = false; // 상셉팝업 닫기
    this._st_detail_delivery_memo_view = false; // 메모 닫기
    this._st_detail_delivery_end_view = false; // 지난상셉팝업 닫기
  }

  /**
   * 상세팝업 열기
   */
  @action
  setDetailLayer() {
    this._st_detail_delivery_view = true;
  }

  /**
   * 지난주문 상세팝업 노출여부
   * @type {boolean}
   * @private
   */
  @observable
  _st_detail_delivery_end_view = false;

  /**
   * 지난주문 상세팝업 값 조회
   * @returns {boolean}
   */
  get getDetailEndView() {
    return this._st_detail_delivery_end_view;
  }

  /**
   * 지난주문 상세팝업 열기
   */
  @action
  setDetailEndLayer() {
    this._st_detail_delivery_end_view = true;
  }

  /**
   * 상세 메모팝업 노출여부
   * @type {boolean}
   * @private
   */
  @observable
  _st_detail_delivery_memo_view = false;

  /**
   * 상세 메모팝업 값 조회
   * @returns {boolean}
   */
  get getDetailMemoView() {
    return this._st_detail_delivery_memo_view;
  }

  /**
   * 상세 메모레이어 닫기
   */
  @action
  setDetailMemoClose() {
    this._st_detail_delivery_memo_view = false;
  }

  /**
   * 상세 메모레이어 열기
   */
  @action
  setDetailMemoLayer() {
    this._st_detail_delivery_memo_view = true;
  }

  /**
   * 메모 수정전 원본값
   * @returns {string}
   */
  @observable
  _st_ori_shop_memo = "";

  get getOriShopMemo() {
    return this._st_ori_shop_memo;
  }

  @action
  setOriShopMemo(memo) {
    this._st_ori_shop_memo = memo;
  }

  @action
  setBackShopMemo(memo) {
    this._st_order_detail.shopMemo = memo;
  }

  /**
   * 취소,거절 연결메뉴 오픈할 대상
   * @type {string}
   * @private
   */
  @observable
  _st_order_sold_out_conn = "";

  get getOrderSoldOutConn() {
    return this._st_order_sold_out_conn;
  }

  @action
  setOrderSoldOutConn(prodCode) {
    this._st_order_sold_out_conn = prodCode;
  }

  /**
   * 품절 처리할 상품목록
   * @type {*[]}
   * @private
   */
  @observable
  _st_order_sold_out_prod = [];

  @computed
  get getOrderSoldOutProd() {
    return this._st_order_sold_out_prod;
  }

  @computed
  get getOrderSoldOutProdUpdate() {
    return this._st_order_sold_out_prod.map(prod => {
      return { prodCd: prod.prodCode, soldOut: prod.soldOutYn };
    });
  }

  @action
  addOrderSoldOutProd(prod) {
    const obj = this._st_order_sold_out_prod.find(obj => obj.prodCode === prod.prodCode);

    // 기존에 없고, 메인상품이면
    if (!obj && prod.prodType === "M") {
      this._st_order_sold_out_prod.push({ ...prod, oriSoldOutYn: prod.soldOutYn });
    }
  }

  @action
  setOrderSoldOutProd(prod) {
    this._st_order_sold_out_prod = this._st_order_sold_out_prod.map(obj => {
      if (obj.prodCode === prod) {
        return { ...obj, soldOutYn: obj.oriSoldOutYn === "Y" ? "Y" : obj.soldOutYn === "N" ? "Y" : "N" };
      } else {
        return obj;
      }
    });
  }

  @action
  initOrderSoldOutProd() {
    this._st_order_sold_out_prod = [];
  }

  /**
   * 주소 검색 변경값
   * @type {string}
   * @private
   */
  @observable
  _st_detail_search_addr_val = "";

  get getDetailSearchAddr() {
    return this._st_detail_search_addr_val;
  }

  @action
  setDetailSearchAddr(val) {
    this._st_detail_search_addr_val = val;
    this._st_search_addr_list = [];
    this._st_search_addr_count = null;
    this.setSearchAddrResult(null);
  }

  @action
  setDetailNowSearchAddr(rootStore, val) {
    this._st_detail_search_addr_val = val;
    this._st_search_addr_list = [];
    this._st_search_addr_count = null;
    this.setSearchAddrResult(null);
    //rootStore.viewStore.setAddrApiName("type", "keyword");
    select_addr_forkakao(rootStore);
    //select_addr_fornaver(rootStore)
  }

  /**
   * 주소 상세 검색 변경값
   * @type {string}
   * @private
   */
  @observable
  _st_detail_search_addr_detail_val = "";

  get getDetailSearchAddrDetail() {
    return this._st_detail_search_addr_detail_val;
  }

  @action
  setDetailSearchAddrDetail(val) {
    this._st_detail_search_addr_detail_val = val;
  }

  // 카카오맵 좌표
  @observable
  _st_kakaoamp = {
    lat: "",
    lng: "",
  };

  get getKakaoMap() {
    return this._st_kakaoamp;
  }

  @computed
  get getKakaoMapLat() {
    return this._st_kakaoamp.lat;
  }

  @computed
  get getKakaoMapLng() {
    return this._st_kakaoamp.lng;
  }

  @action
  setKakaoMap(lat_val, lng_val) {
    this._st_kakaoamp = { lat: lat_val, lng: lng_val };
  }

  /**
   * 주소 검색 카운트 수(너무 많은 경우 표기를 위함)
   * @type {[]}
   * @private
   */
  @observable
  _st_search_addr_count = 0;

  @computed
  get getSearchAddrCount() {
    return this._st_search_addr_count;
  }

  @action
  setSearchAddrCount(count) {
    this._st_search_addr_count = count;
  }

  /**
   * 주소 검색후 목록 관리
   * @type {[]}
   * @private
   */
  @observable
  _st_search_addr_list = [];

  @computed
  get getSearchAddrList() {
    return toJS(this._st_search_addr_list);
  }

  @action
  setSearchAddrList(list) {
    this._st_search_addr_list = list.map(addr => {
      return { ...addr, click_obj: false, id: addr.id };
    });
  }

  @action
  initSearchAddrList() {
    this._st_search_addr_list = [];
  }

  @action
  setSearchAddrClickObj(addr_name, id) {
    this._st_search_addr_list = this._st_search_addr_list.map(addr => {
      if (addr.address === addr_name && id === addr.id) {
        return { ...addr, click_obj: true };
      } else {
        return { ...addr, click_obj: false };
      }
    });
  }

  /**
   * 주소 검색 오류 상태
   * @type String
   * @private
   */
  @observable
  _st_search_addr_result = "";

  @computed
  get getSearchAddrResult() {
    return this._st_search_addr_result;
  }

  @action
  setSearchAddrResult(resultValue) {
    /* none, many */
    this._st_search_addr_result = resultValue;
  }

  /**
   * 주소 검색 api
   * @type String
   * @private
   */
  @observable
  _st_search_api_name = {
    api: "kakao",
    type: "",
  };

  @computed
  get getAddrApiName() {
    return this._st_search_api_name;
  }

  @action
  setAddrApiName(key, value) {
    this._st_search_api_name = { ...this._st_search_api_name, [key]: value };
  }

  /**
   * 선택한 배달주소지 정보
   * @type {{}}
   * @private
   */
  @observable
  _st_selected_addr = null;

  get getSelectedAddr() {
    return this._st_selected_addr;
  }

  @action
  setSelectedAddr(addr) {
    this._st_selected_addr = addr;
  }

  @action
  initSelectedAddr() {
    this._st_selected_addr = null;
  }

  @computed
  get getSelectAddrVal() {
    if (!this._st_selected_addr) {
      return "";
    }
    return this._st_selected_addr.address ? this._st_selected_addr.address.address_name : "";
  }

  @computed
  get getSelectRoadAddrVal() {
    if (!this._st_selected_addr) {
      return "";
    }
    return this._st_selected_addr.road_address ? this._st_selected_addr.road_address.address_name : "";
  }

  @observable
  _addr_box_show_flag = false;

  get getAddrBoxShowFlag() {
    return this._addr_box_show_flag;
  }

  @action
  setAddrBoxShowFlag(flag) {
    this._addr_box_show_flag = flag;
  }

  @observable
  _st_customer_pop_btn = {
    min1: "N",
    min5: "N",
    min10: "N",
    min15: "N",
    min20: "N",
    min25: "N",
    min30: "N",
    min45: "N",
    min60: "N",
    min90: "N",
    min120: "N",
  };

  @computed
  get getCustomerPopBtn() {
    return this._st_customer_pop_btn;
  }

  @action
  initCustomerPopBtn() {
    this._st_customer_pop_btn = {
      min1: "N",
      min5: "N",
      min10: "N",
      min15: "N",
      min20: "N",
      min25: "N",
      min30: "N",
      min45: "N",
      min60: "N",
      min90: "N",
      min120: "N",
    };
  }

  @action
  setCustomerPopBtn(key, value) {
    this._st_customer_pop_btn = { ...this._st_customer_pop_btn, [key]: value };
  }

  @observable
  _st_customer_pop_btn_ygy = {
    min5: "N",
    min10: "N",
    min15: "N",
    min20: "N",
    min25: "N",
    min30: "N",
  };

  @computed
  get getCustomerPopBtnYgy() {
    return this._st_customer_pop_btn_ygy;
  }

  @action
  initCustomerPopBtnYgy() {
    this._st_customer_pop_btn_ygy = {
      min5: "N",
      min10: "N",
      min15: "N",
      min20: "N",
      min25: "N",
      min30: "N",
    };
  }

  @action
  setCustomerPopBtnYgy(key, value) {
    this._st_customer_pop_btn_ygy = { ...this._st_customer_pop_btn_ygy, [key]: value };
  }

  @observable
  _st_vocs_detail = {
    vocMsg: "",
    hpTelNo: "",
    agree: false,
    val: "",
  };

  @computed
  get getVocsDetail() {
    return this._st_vocs_detail;
  }

  @action
  setVocsDetail(key, value) {
    this._st_vocs_detail = { ...this._st_vocs_detail, [key]: value };
  }

  @computed
  get getVocsAgreeDetail() {
    return this._st_vocs_detail.agree;
  }

  @action
  setVocsAgreeDetail(value) {
    this._st_vocs_detail.agree = value;
  }

  @action
  setVocsInitDetail() {
    this._st_vocs_detail = {
      vocMsg: "",
      hpTelNo: "",
      agree: false,
      val: "",
    };

    this._st_vocs_type_key_val = {
      code: "",
      val: "유형을 선택하세요",
    };
  }

  @observable
  _st_layer_vocs_type_view = false;

  get getLayerVocsTypeView() {
    return this._st_layer_vocs_type_view;
  }
  @action
  setLayerVocsTypeView(viewBl) {
    this._st_layer_vocs_type_view = viewBl;
  }

  @observable
  _st_vocs_type_key_val = {
    code: "",
    val: "유형을 선택하세요",
  };

  @computed
  get getVocsTypeKeyVal() {
    return this._st_vocs_type_key_val;
  }

  @action
  setVocsTypeKeyVal(key, val) {
    this._st_vocs_type_key_val = { ...this._st_vocs_type_key_val, [key]: val };
  }

  @observable
  _end_order_view_type = "";

  get getEndOrderViewType() {
    return this._end_order_view_type;
  }

  @action
  setEndOrderViewType(flag) {
    this._end_order_view_type = flag;
  }

  @observable
  _st_login_auth_detail = "";

  get getLoginAuthDetail() {
    return this._st_login_auth_detail;
  }

  @action
  setLoginAuthDetail(txt) {
    this._st_login_auth_detail = txt;
  }

  /**
   * 배민 상세 팝업 노출 여부
   */
  @observable
  _st_detail_baemin_view = false;

  get getDetailBaeminView() {
    return this._st_detail_baemin_view;
  }

  @action
  setDetailBaeminView(flag) {
    this._st_detail_baemin_view = flag;
  }

  /**
   * 전체완료 배민주문 포함 여부
   */
  @observable
  _st_allComplete_baemin_list = false;

  get getAllCompleteBaeminList() {
    return this._st_allComplete_baemin_list;
  }

  @action
  setAllCompleteBaeminList(flag) {
    this._st_allComplete_baemin_list = flag;
  }

  /**
   * 거절/취소 팝업
   */
  @observable
  _st_order_end_type = "";

  get getOrderEndType() {
    return this._st_order_end_type;
  }

  @action
  setOrderEndType(type) {
    this._st_order_end_type = type;
  }

  /**
   * 지난주문 여부
   */
  @observable
  _st_order_end_view = false;

  get getOrderEndView() {
    return this._st_order_end_view;
  }

  @action
  setOrderEndView(type) {
    this._st_order_end_view = type;
  }

  @observable
  _st_clicked_address = "";

  get getClickedAddress() {
    return this._st_clicked_address;
  }

  @action
  setClickedAddress(address) {
    this._st_clicked_address = address;
  }

  /**
   * 미완료메뉴 기준시간
   */
  @observable
  _st_incomplete_menu_time = "";

  get getIncompleteMenuNewTime() {
    return this._st_incomplete_menu_time;
  }
  @action
  setIncompleteMenuNewTime(val) {
    this._st_incomplete_menu_time = val;
  }

  /**
   * 노쇼처리
   */
  @observable
  _st_no_show_check = false;

  get getNoShowCheck() {
    return this._st_no_show_check;
  }

  @action
  setNoShowCheck(type) {
    this._st_no_show_check = type;
  }
}

export default new ViewStore();
